<template>
  <div>
    <div class="metric-list" v-if="!metrics.length">
      <SmartMetricItem v-for="index in fakeMetrics" :key="index" />
    </div>
    <div class="metric-list" v-if="metrics.length && !questionsStatus">
      <SmartMetricItem
        v-for="metric in metrics"
        :metricType="metricType"
        :key="metric.id"
        :metric="metric"
        :canViewMetricsInfo="canViewMetricsInfo"
      />
    </div>
    <div v-if="metrics.length && questionsStatus">
      <MetricItemWithQuestion
        v-for="(metric, index) in metrics"
        :key="metric.id"
        :metric="metric"
        :index="index"
        :metricsSize="metrics.length"
      />
    </div>
  </div>
</template>

<script>
import SmartMetricItem from './SmartMetricItem.vue'
import MetricItemWithQuestion from './MetricItemWithQuestion.vue'

const props = {
  list: {
    require: true,
    type: Array,
  },
  metricType: {
    require: false,
    type: String,
    default: 'list',
  },
  questionsStatus: {
    require: false,
    type: Boolean,
    default: false,
  },
  canViewMetricsInfo: {
    require: true,
    type: Boolean,
  },
  isManager: {
    require: false,
    type: Boolean,
  },
}

export default {
  components: { SmartMetricItem, MetricItemWithQuestion },
  props: props,
  computed: {
    fakeMetrics() {
      return this.isManager ? [1, 2] : [1, 2, 3]
    },
    metrics: function() {
      return this.list || []
    },
  },
  beforeDestroy: function() {
    if (this.list) {
      this.list.length = 0
    }
  },
}
</script>

<style lang="scss" scoped>
.metric-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
</style>
